import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'agl-contact-intro',
  templateUrl: './contact-intro.component.html',
  styleUrls: ['./contact-intro.component.scss']
})
export class ContactIntroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
